import React from 'react';

import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';

interface IDateTimeProps {
	className?: string;
	children: number | string;
	format?: string;
	isUTC?: boolean;
}

const DateTime = (props: IDateTimeProps) => {
	const { className, format = 'MMM DD, YYYY', children, isUTC = false } = props;

	const getDateTime = (isUTC: boolean) => {
		if (dayjs(children).isValid()) {
			if (isUTC) {
				dayjs.extend(utc);
				return dayjs.utc(children).format(format);
			}
			return dayjs(children).format(format);
		}

		return children;
	};

	return <time className={className}>{getDateTime(isUTC)}</time>;
};

export default DateTime;
